<template>
  <HeadWrapper title="Billing" />

  <ConfigWrapper>
    <div id="app">
      <router-view />
    </div>
  </ConfigWrapper>
</template>

<script setup>
import HeadWrapper from '@/components/layout_components/HeadWrapper.vue';
import ConfigWrapper from '@/components/layout_components/ConfigWrapper.vue';
</script>
